(function () {
  const OPEN_CLASS = 'is-open';

  function init(note) {
    if (note.dataset.photoNoteReady === 'true') return;
    note.dataset.photoNoteReady = 'true';

    const trigger = note.querySelector('.product-photo-note__trigger');
    if (!trigger) return;

    const open = () => {
      note.classList.add(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      note.classList.remove(OPEN_CLASS);
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      note.classList.contains(OPEN_CLASS) ? close() : open();
    });

    document.addEventListener('click', (event) => {
      if (note.classList.contains(OPEN_CLASS) && !note.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && note.classList.contains(OPEN_CLASS)) {
        close();
        trigger.focus();
      }
    });
  }

  const boot = () => document.querySelectorAll('.product-photo-note').forEach(init);

  boot();
  document.addEventListener('shopify:section:load', boot);
})();